module.exports = __webpack_public_path__ + "img/onplanned-sectordetail.04afa6b8.svg";